import React from 'react';
import { bool, number, string } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';

import css from './ConfirmedBadge.module.css';

const ConfirmedBadge = (props) => {
  const {
    className,
    intl,
  } = props;
  const text = intl.formatMessage({ id: 'ConfirmedBadge' });
  const classes = css.root;
  const swimPlusDiscountTextClasses = css.swimPlusDiscountText;

  return (
    <div className={classes}>
      <span className={swimPlusDiscountTextClasses}>{text}</span>
    </div>
  )
}

ConfirmedBadge.defaultProps = {
  className: null,
  iconOnly: false,
  swimPlusDiscountFrom: null,
  textOnly: false,
  withModal: false,
};

ConfirmedBadge.propTypes = {
  className: string,
  iconOnly: bool,
  swimPlusDiscountFrom: number,
  intl: intlShape.isRequired,
  textOnly: bool,
  withModal: bool,
};

export default injectIntl(ConfirmedBadge);
